import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { OnyxIconComponent } from '@onyx/angular';

@Component({
  selector: 'app-unavailability-file-cell',
  imports: [OnyxIconComponent, TranslatePipe],
  templateUrl: './unavailability-file-cell.component.html',
  styleUrl: './unavailability-file-cell.component.scss',
})
export class UnavailabilityFileCellComponent {
  public readonly file = input.required<File | string | null>();
  public readonly showFile = input<(file: File | string) => void>();

  protected readonly I18N = 'unavailabilities';
}
